import LogoTgk from '@/assets/logo-thurgaukultur.svg';
import type { CustomerVariables } from '@/@types/globals';

export function defineVariables(defaultVariables: CustomerVariables): CustomerVariables {
    const thisYear = new Date().getFullYear();
    defaultVariables.logo = { image: LogoTgk, width: 300, height: 44, alt: 'thurgaukultur.ch Logo' };
    defaultVariables.signupUrl = '/service/meineveranstaltungen';
    defaultVariables.loginFooterHtml = `
        <p class="tgk-paragraph-text">
        (c) 2009-${thisYear} thurgaukultur.ch. All rights reserved.<br>
        <a href="https://www.thurgaukultur.ch/service/genre/ueber-uns/sub/datenschutzerklaerung">Datenschutz</a> |
        <a href="https://www.thurgaukultur.ch/service/genre/ueber-uns/sub/impressum">Impressum</a>
        </p>
        `;
    defaultVariables.vuetifyThemeColors = {
        primary: '#E3004F',
        primaryToggled: '#B80040',
        secondary: '#424242',
        anchor: '#E3004F',
        accent: '#82B1FF',
        action: '#E3004F',
        error: '#FF5252',
        attention: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    };

    return defaultVariables;
}
